import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI
import { Card, CardContent } from "@mui/material";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AccountTreeIcon from "@mui/icons-material/AccountTree"; // Ícone para Partições
import SensorsIcon from "@mui/icons-material/Sensors"; // Ícone para Zonas
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';

import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MonitorIcon from '@mui/icons-material/Monitor';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import TerminalIcon from '@mui/icons-material/Terminal';
import LanIcon from '@mui/icons-material/Lan';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import FaceIcon from '@mui/icons-material/Face';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import RefreshIcon from '@mui/icons-material/Refresh';

import api from '../../../../../../services/api';


import NavegadorGestao from "../../../../../../components/NavBarGestao";


import switch_off from '../../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../../assets/imgs/icone_call.png';


import sem_tensao from '../../../../../../assets/imgs/sem_tensao.png';
import tensao_ac from '../../../../../../assets/imgs/tensao_ac.png';


import cabo_conectado from '../../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../../assets/imgs/wifi_conectado.png';
import wifi_desconectado from '../../../../../../assets/imgs/wifi_desconectado.png';
import wifi_internet from '../../../../../../assets/imgs/cabo_internet.png';
import wifi_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import modem_conectado from '../../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../../configs/globalConfigs';


import ConfiguracoesReproducao from '../../../../../../pages/painelAdmin/AreaGestao/ModuloAdministracao/Equipamentos/ModuloSonoro/configuracoesReproducao.js';
import SipCallComponent from '../SipCallComponent/index.js';

import { Modal} from "@mui/material";

import {
    GoogleMap,
    Marker,
    LoadScript,
    OverlayView,
    StandaloneSearchBox,
    DirectionsService,
    DirectionsRenderer,
    DistanceMatrixService,
    Circle, Polygon, Polyline
} from "@react-google-maps/api";

import "./MapPage.css";
import alarmeAudio from '../../../../../../assets/mp3/alarme.mp3';





export default function ModuloSonoroComponent(props) {


    const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag, id_sigma, useNativeCall, setUseNativeCall, sipStatus, activeCallRamal, onSipCall, onSipHangup } = props;
    const tempoInativo = 3;

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);



    const [larguraOriginal, setLarguraOriginal] = useState(0);

    const [limiar, setLimiar] = useState(900);
    const [openLogTable, setOpenLogTable] = useState(false);
    const [openVideoAgent, setOpenVideoAgent] = useState(false);
    const [urlAgentDVRFetch, setUrlAgentDVRFetch] = useState('');
    const [loadingVideo, setLoadingVideo] = useState(false);
    const [openAlarmeVideo, setOpenAlarmeVideo] = useState(false);
    const [openAlarmeImage, setOpenAlarmeImage] = useState(false);
    const [selectedAlarmeVideoUrls, setSelectedAlarmeVideoUrls] = useState([]);
    const [selectedAlarmeImageUrls, setSelectedAlarmeImageUrls] = useState([]);
    const [selectedAlarmeVideoUrl, setSelectedAlarmeVideoUrl] = useState('');
    const [selectedAlarmeRow, setSelectedAlarmeRow] = useState(null);

    const processVideoUrl = (url) => {
        if (!url) return null;
        let processedUrl = url;
        processedUrl = processedUrl.replace('/home/wwgrup/alarmes/', 'https://gruporosinetos.com/alarmemidias/');
       
        return processedUrl;
    };




    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        setLarguraOriginal(largura);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });

    const Zone = ({ zoneData }) => {

        const {
            id,
            nome,
            zoneStatus,
            armeStatus,
            zoneAlarme,
        } = zoneData;

        return (
            <Card sx={{ margin: 2, padding: 2, backgroundColor: "#f5f5f5" }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Zona {id}: {nome}
                    </Typography>
                    <Box sx={{ whiteSpace: "pre-line" }}>
                        <Typography><b>Online?</b> {zoneStatus}  </Typography>
                        <Typography><b>Armada?</b> {armeStatus}  </Typography>
                        <Typography><b>Em Alarme?</b> {zoneAlarme}</Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    };


    useEffect(() => {



        checkDimenssoes();



    }, []);


    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const [modalSigmaOpen, setModalSigmaOpen] = useState(false);
    const [selectedTarefaSigma, setSelectedTarefaSigma] = useState(null);
    const [selectedEventoRow, setSelectedEventoRow] = useState(null);

    const handleAbrirModalSigma = (sigma, row) => {
        setSelectedTarefaSigma(sigma);
        setSelectedEventoRow(row);
        setModalSigmaOpen(true);
    };


    const handleOpenVideoAgent = async () => {
        setOpenVideoAgent(true);
        if (equipamento.modulo_sonoro && equipamento.modulo_sonoro.id_modulo_sonoro) {
            setLoadingVideo(true);
            try {
                const token = Cookies.get('token');
                const response = await api.get(`v1/protected/modulosonoro/listarporid/${equipamento.modulo_sonoro.id_modulo_sonoro}`, {
                    headers: { 'Authorization': 'Bearer ' + token }
                });
                if (response.data && response.data.url_agent_dvr) {
                    setUrlAgentDVRFetch(response.data.url_agent_dvr);
                } else {
                    setUrlAgentDVRFetch('');
                }
            } catch (error) {
                console.error("Erro ao buscar URL do Agent DVR:", error);
                setUrlAgentDVRFetch('');
            } finally {
                setLoadingVideo(false);
            }
        }
    };







    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };


    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [objetoGerenciado, setObjetoGerenciado] = useState(null);

    async function buscarInformacoesInstalacao() {
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };
            const response = await api.get("/v1/protected/cliente/instalacoes/listarporid/" + id_instalacao, { headers });
            setObjetoGerenciado(response.data);
        } catch (error) {
            console.error("Erro ao buscar informações da instalação:", error);
        }
    }

    const handleMenuToggleRotas = () => {
        if (!objetoGerenciado) {
            buscarInformacoesInstalacao();
        }
        setIsDrawerOpen(!isDrawerOpen);
        handleMenuClose();
    };

    function acessarMonitor(url) {
        window.open(url);
        handleMenuClose();
    }

    function acessoRemoto(url) {
        window.open(url);
        handleMenuClose();
    }

    function acessoSshRemoto(url) {
        window.open(url);
        handleMenuClose();
    }

    async function handleClickAcessoEquipamentoRemoto(id, ip, porta, server) {
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulosonoro/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + id + "/200/0/0/0/0/" + ip + "/" + porta + "/" + server + "/0";
            await api.get(url, { headers });
            setSnackbarMessage('Comando Enviado, Aguarde enquanto a Rota para o acesso remoto é criada!');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }

    function criarRotaAcessoRemoto(equipamentoAcessar, server) {
        let serverNum = server.replace(/\D/g, '');
        let rota = "";

        if (objetoGerenciado) {
            if (serverNum === "1") rota = objetoGerenciado.url_rota_acesso_remoto1;
            else if (serverNum === "2") rota = objetoGerenciado.url_rota_acesso_remoto2;
            else if (serverNum === "3") rota = objetoGerenciado.url_rota_acesso_remoto3;
            else if (serverNum === "4") rota = objetoGerenciado.url_rota_acesso_remoto4;
            else if (serverNum === "5") rota = objetoGerenciado.url_rota_acesso_remoto5;
            else if (serverNum === "6") rota = objetoGerenciado.url_rota_acesso_remoto6;
        }

        handleClickAcessoEquipamentoRemoto(equipamentoAcessar.modulo_sonoro.id_modulo_sonoro, equipamentoAcessar.ip, equipamentoAcessar.porta, serverNum);

        if (rota) {
            setTimeout(() => {
                window.open(rota);
            }, 3000);
        }
        setIsDrawerOpen(false);
    }

    const [openReproducao, setOpenReproducao] = useState(false);

    const handleCloseReproducao = () => {
        setOpenReproducao(false);
    }

    const [logsPgm, setLogsPgm] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [isFetchingLogs, setIsFetchingLogs] = useState(false);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [customSearch, setCustomSearch] = useState('');

    const filteredLogs = useMemo(() => {
        if (!logsPgm) return [];
        if (!customSearch.trim()) return logsPgm;
        const term = customSearch.toLowerCase();
        return logsPgm.filter(row => {
            const id = String(row.id_tarefa || '');
            const user = String(row.usuario_nome || row.nome_usuario || row.usuario || row.user_name || row.usuario_executou || row.nome || '');
            const req = String(row.data_hora_requisicao || '');
            const resp = String(row.data_hora_resposta || '');
            const tipo = String(row.tipo_requisicao || '');
            const val1 = String(row.valor_string || '');
            const val2 = String(row.valor_string2 || '');
            const origem = String(row.origem || '');
            return id.toLowerCase().includes(term) ||
                   user.toLowerCase().includes(term) ||
                   req.toLowerCase().includes(term) ||
                   resp.toLowerCase().includes(term) ||
                   tipo.toLowerCase().includes(term) ||
                   val1.toLowerCase().includes(term) ||
                   val2.toLowerCase().includes(term) ||
                   origem.toLowerCase().includes(term);
        });
    }, [logsPgm, customSearch]);

    useEffect(() => {
        if (openLogTable) {
            fetchLogsData();
        }
    }, [pagination.pageIndex, pagination.pageSize, openLogTable]);

    async function fetchLogsData(pi = pagination.pageIndex, ps = pagination.pageSize) {
        setIsFetchingLogs(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const offset = pi * ps;
            const url = `/v1/protected/modulosonoro/tarefas/listarpagina/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_sonoro.id_modulo_sonoro + "/" + ps + "/" + offset;
            const response = await api.get(url, { headers });

            if (response.data && response.data.data) {
                const dados = processarDadosLogs(response.data.data);
                setLogsPgm(dados);
                setRowCount(response.data.total);

                // Carregamento resiliente de TarefaSigma caso o backend não tenha retornado acoplado
                const tarefasSemSigma = dados.filter(d => !d.tarefa_sigma && d.id_tarefa);
                if (tarefasSemSigma.length > 0) {
                    Promise.all(tarefasSemSigma.map(async (t) => {
                        try {
                            const resSigma = await api.get(`/v1/protected/modulosonoro/tarefas/sigma/${t.id_tarefa}`, { headers });
                            if (resSigma.data && resSigma.data.id_tarefa_sigma) {
                                return { id_tarefa: t.id_tarefa, tarefa_sigma: resSigma.data };
                            }
                        } catch (e) {}
                        return null;
                    })).then(results => {
                        const sigmasEncontradas = results.filter(Boolean);
                        if (sigmasEncontradas.length > 0) {
                            setLogsPgm(prev => prev.map(p => {
                                const found = sigmasEncontradas.find(s => s.id_tarefa === p.id_tarefa);
                                if (found) {
                                    let novoUser = p.usuario_executor;
                                    if ((novoUser === '-' || !novoUser) && found.tarefa_sigma.corpo_requisicao && found.tarefa_sigma.corpo_requisicao.includes('O usuario ')) {
                                        const m = found.tarefa_sigma.corpo_requisicao.match(/O usuario\s+([^ ]+(?:\s+[^ ]+)*?)\s+(?:armou|desarmou)/i);
                                        if (m && m[1] && m[1] !== 'X') novoUser = m[1];
                                    }
                                    return {
                                        ...p,
                                        tarefa_sigma: found.tarefa_sigma,
                                        usuario_executor: novoUser
                                    };
                                }
                                return p;
                            }));
                        }
                    });
                }
            } else if (Array.isArray(response.data)) {
                const dados = processarDadosLogs(response.data);
                setLogsPgm(dados);
                setRowCount(dados.length);
            }
        } catch (error) {
            console.error("Erro ao buscar logs:", error);
        } finally {
            setIsFetchingLogs(false);
        }
    }

    async function handleClickLog() {
        setPagination({ pageIndex: 0, pageSize: 10 });
        setOpenLogTable(true);
        fetchLogsData(0, 10);
    }

    const tipoRequisicaoMap = {
        0: "Acionar Ambos Reles",
        1: "Acionar Rele 1",
        2: "Acionar Rele 2",
        3: "Desligar Ambos Reles",
        4: "Desligar Rele 1",
        5: "Desligar Rele 2",
        6: "Reproduzir Audio Personalizado 1",
        7: "Reproduzir Audio Personalizado 2",
        8: "Reproduzir Audio Personalizado 3",
        9: "Reproduzir Audio Personalizado 4",
        10: "Reproduzir Audio Personalizado 5",
        20: "Desativar Automação Geral",
        21: "Ativar Automação Geral",
        22: "Reiniciar PGM",
        23: "Desativar Automação dos Reles",
        24: "Ativar Automação dos Reles",
        25: "Desativar Automação da Corneta",
        26: "Ativar Automação da Corneta",
        27: "Armar Central em Stay",
        28: "Armar Central em Away",
        29: "Desativar Central",
        50: "Central Armada",
        51: "Central Desarmada",
        52: "Central em Alarme",
        90: "Camera Agent DVR Alarme",
        93: "Pré-Alarme de Temperatura - Câmera Térmica",
        94: "Alarme de Temperatura Efetivo - Câmera Térmica",
        15: "Controle de Volume do Modulo Unifier",
        40: "Arme do Modulo Unifier",
        41: "Desarme do Modulo Unifier",
        92: "Reconhecimento Facial",
    };

    const respondidoModuloPgmMap = {
        0: "Não Respondido",
        1: "Respondido"
    };

    const processarDadosLogs = (dados) => {
        return dados.map((item) => {
            let nomeUser = item.usuario_executor || item.usuario_executou || item.usuario_nome || item.nome_usuario || item.usuario || item.user_name || item.nome || null;
            if (!nomeUser && item.tarefa_sigma && item.tarefa_sigma.corpo_requisicao) {
                const matchComplement = item.tarefa_sigma.corpo_requisicao.match(/O usuario\s+([^ ]+(?:\s+[^ ]+)*?)\s+(?:armou|desarmou)/i);
                if (matchComplement && matchComplement[1] && matchComplement[1] !== 'X') {
                    nomeUser = matchComplement[1];
                }
            }
            if (!nomeUser && item.valor_string2 && item.valor_string2.includes('Pessoa:')) {
                const matchPessoa = item.valor_string2.match(/Pessoa:\s*([^|]+)/);
                if (matchPessoa && matchPessoa[1]) {
                    nomeUser = matchPessoa[1].trim();
                }
            }

            return {
                ...item, // Mantém os outros atributos
                usuario_executor: nomeUser || '-',
                data_hora_requisicao: moment(item.data_hora_requisicao).isValid()
                    ? moment(item.data_hora_requisicao).format('HH:mm:ss DD/MM/YYYY')
                    : item.data_hora_requisicao, // Formata a data ou mantém o valor original
                data_hora_resposta: moment(item.data_hora_resposta).isValid()
                    ? moment(item.data_hora_resposta).format('HH:mm:ss DD/MM/YYYY')
                    : item.data_hora_resposta, // Formata a data ou mantém o valor original
                tipo_requisicao: tipoRequisicaoMap[item.tipo_requisicao] || "Tipo Desconhecido", // Mapeia o tipo
                origem: item.origem === 0 ? "Local" : "Remoto", // Mapeia a origem
                respondido_modulo_sonoro: respondidoModuloPgmMap[item.respondido_modulo_sonoro] || "Status Desconhecido", // Mapeia o status de respondido
            };
        });
    };



    const extractEventString = (original) => {
        const logData = (original.valor_string || '') + ' ' + (original.valor_string2 || '');
        let tipoEvento = original.tipo_requisicao || 'N/A';
        if (logData.includes('Tipo:')) {
            const match = logData.match(/Tipo:\s*([^|]+)/);
            if (match) tipoEvento = match[1].trim();
        }

        let ipDispositivo = original.origem || 'N/A';
        if (logData.includes('IP Câmera:')) {
            const match = logData.match(/IP Câmera:\s*([^|]+)/);
            if (match) ipDispositivo = match[1].trim();
        }

        let idEquipamento = 'N/A';
        if (logData.includes('ID Equipamento:')) {
            const match = logData.match(/ID Equipamento:\s*([^|]+)/);
            if (match) idEquipamento = match[1].trim();
        }

        let tipoDispositivo = 'Desconhecido';
        if (original.tipo_requisicao === 93 || original.tipo_requisicao === 94 ||
            (original.tipo_requisicao && (String(original.tipo_requisicao).includes('Térmica') || String(original.tipo_requisicao).includes('Temperatura')))) {
            tipoDispositivo = 'Câmera Térmica';
        } else if (original.tipo_requisicao === 'ALARME_CAMERA' || original.tipo_requisicao === 'Camera Agent DVR Alarme') {
            tipoDispositivo = 'Câmera IP';
        } else if (original.tipo_requisicao && original.tipo_requisicao.includes('Central')) {
            tipoDispositivo = 'Central de Alarme';
        } else {
            tipoDispositivo = 'Módulo Sonoro';
        }

        let nomeZona = 'N/A';
        if (logData.includes('Zona:')) {
            const match = logData.match(/Zona:\s*([^|]+)/);
            if (match) nomeZona = match[1].trim();
        } else if (original.valor_string3 && original.valor_string3 !== 'null') {
            nomeZona = original.valor_string3;
        }

        let pessoa = '';
        if (logData.includes('Pessoa:')) {
            const match = logData.match(/Pessoa:\s*([^|]+)/);
            if (match) pessoa = match[1].trim();
        }

        let result = `Evento: ${tipoEvento}\nIP: ${ipDispositivo}\nDisp: ${tipoDispositivo}`;
        if (idEquipamento !== 'N/A') result += `\nID: ${idEquipamento}`;
        if (nomeZona !== 'N/A') result += `\nZona: ${nomeZona}`;
        if (pessoa) result += `\nPessoa: ${pessoa}`;
        return result;
    };

    const getExportData = () => {
        return logsPgm.map((log) => {
            const infoExtra = log.valor_string2 ? log.valor_string2.replace(/\\n/g, '\n') : '';
            return {
                'ID': log.id_tarefa,
                'Usuário': log.usuario_executor || log.usuario_executou || log.usuario || '-',
                'Data Requisição': log.data_hora_requisicao,
                'Evento': extractEventString(log),
                'Info Extra': infoExtra,
                'Origem': log.origem,
                'Respondido': log.respondido_modulo_sonoro
            };
        });
    };

    const handleExportDataPDF = () => {
        const doc = new jsPDF('l'); 
        const exportData = getExportData();
        if (exportData.length === 0) return;
        
        const head = [Object.keys(exportData[0])];
        const tableData = exportData.map(obj => Object.values(obj));
        
        autoTable(doc, {
            head: head,
            body: tableData,
            styles: { cellWidth: 'wrap' },
            columnStyles: {
                2: { cellWidth: 80 }, 
                3: { cellWidth: 80 }  
            }
        });
        doc.save('historico_eventos_modulo_sonoro.pdf');
    };

    const handleExportDataExcel = () => {
        const exportData = getExportData();
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        
        const colWidths = [];
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
            let max = 15; 
            for (let R = range.s.r; R <= range.e.r; ++R) {
                const cell = worksheet[XLSX.utils.encode_cell({c: C, r: R})];
                if (cell && cell.v) {
                    if (cell.t === 's') {
                        cell.s = { alignment: { wrapText: true } };
                    }
                    const lines = cell.v.toString().split('\n');
                    lines.forEach(line => {
                        if (line.length > max) max = line.length;
                    });
                }
            }
            colWidths[C] = { wch: max + 2 };
        }
        worksheet['!cols'] = colWidths;
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Eventos");
        XLSX.writeFile(workbook, "historico_eventos_modulo_sonoro.xlsx");
    };

    const colunasLogsPgm = useMemo(
        () => [
            {
                accessorKey: 'id_tarefa',
                header: 'ID',
                size: 35,
            },
            {
                id: 'usuario_executou',
                header: 'Usuário',
                size: 75,
                accessorFn: (row) => row.usuario_executor || row.usuario_executou || row.usuario_nome || row.nome_usuario || row.usuario || row.user_name || row.nome || (row.tarefa_sigma && row.tarefa_sigma.corpo_requisicao && row.tarefa_sigma.corpo_requisicao.includes('O usuario ') ? (row.tarefa_sigma.corpo_requisicao.match(/O usuario\s+([^ ]+(?:\s+[^ ]+)*?)\s+(?:armou|desarmou)/i) || [])[1] : null) || '-',
                Cell: ({ row }) => {
                    const original = row.original;
                    const user = original.usuario_executor || original.usuario_executou || original.usuario_nome || original.nome_usuario || original.usuario || original.user_name || original.nome || (original.tarefa_sigma && original.tarefa_sigma.corpo_requisicao && original.tarefa_sigma.corpo_requisicao.includes('O usuario ') ? (original.tarefa_sigma.corpo_requisicao.match(/O usuario\s+([^ ]+(?:\s+[^ ]+)*?)\s+(?:armou|desarmou)/i) || [])[1] : null) || '-';
                    return (
                        <span style={{ fontSize: '11px', fontWeight: 600, color: '#334155' }}>
                            {user}
                        </span>
                    );
                }
            },
            {
                accessorKey: 'data_hora_requisicao',
                header: 'Data Requisição',
                size: 110,
            },
            {
                accessorKey: 'data_hora_resposta',
                header: 'Data Resposta',
                size: 110,
            },
            {
                accessorKey: 'tipo_requisicao',
                header: 'Tipo',
                size: 110,
                Cell: ({ cell, row }) => {
                    let val = cell.getValue() || row.original.tipo_requisicao || '-';
                    if (val === 'Camera Agent DVR Alarme' || val === 'ALARME_CAMERA') {
                        val = 'Alarme em Câmera';
                    }
                    const isAlm = val.toLowerCase().includes('alarme');
                    return (
                        <span style={{
                            fontSize: '11px',
                            fontWeight: '600',
                            color: isAlm ? '#dc2626' : '#475569',
                            backgroundColor: isAlm ? '#fef2f2' : 'transparent',
                            padding: '3px 6px',
                            borderRadius: '4px',
                            border: isAlm ? '1px solid #fecaca' : 'none'
                        }}>
                            {val}
                        </span>
                    );
                }
            },
            {
                id: 'evento_resumo',
                header: 'Evento',
                size: 160,
                Cell: ({ row }) => {
                    const original = row.original;
                    const logData = (original.valor_string || '') + ' ' + (original.valor_string2 || '');
                    
                    let rawTipoRequisicao = original.tipo_requisicao || '';
                    if (rawTipoRequisicao === 'Camera Agent DVR Alarme' || rawTipoRequisicao === 'ALARME_CAMERA') {
                        rawTipoRequisicao = 'Alarme em Câmera';
                    }

                    let tipoEvento = rawTipoRequisicao || 'N/A';
                    if (logData.includes('Tipo:')) {
                        const match = logData.match(/Tipo:\s*([^|]+)/);
                        if (match) tipoEvento = match[1].trim();
                    }

                    let ipDispositivo = original.origem || 'N/A';
                    if (logData.includes('IP Câmera:')) {
                        const match = logData.match(/IP Câmera:\s*([^|]+)/);
                        if (match) ipDispositivo = match[1].trim();
                    }

                    let idEquipamento = 'N/A';
                    if (logData.includes('ID Equipamento:')) {
                        const match = logData.match(/ID Equipamento:\s*([^|]+)/);
                        if (match) idEquipamento = match[1].trim();
                    }

                    let tipoDispositivo = 'Desconhecido';
                    if (original.tipo_requisicao === 'ALARME_CAMERA' || original.tipo_requisicao === 'Camera Agent DVR Alarme' || rawTipoRequisicao === 'Alarme em Câmera') {
                        tipoDispositivo = 'Câmera IP';
                    } else if (original.tipo_requisicao && original.tipo_requisicao.includes('Central')) {
                        tipoDispositivo = 'Central de Alarme';
                    } else {
                        tipoDispositivo = 'Módulo Sonoro';
                    }

                    let nomeZona = 'N/A';
                    if (logData.includes('Zona:')) {
                        const match = logData.match(/Zona:\s*([^|]+)/);
                        if (match) nomeZona = match[1].trim();
                    } else if (original.valor_string3 && original.valor_string3 !== 'null') {
                        nomeZona = original.valor_string3;
                    }

                    let pessoa = '';
                    if (logData.includes('Pessoa:')) {
                        const match = logData.match(/Pessoa:\s*([^|]+)/);
                        if (match) pessoa = match[1].trim();
                    }

                    const fullTextLower = (tipoEvento + ' ' + logData + ' ' + (original.tipo_requisicao || '')).toLowerCase();
                    const isSmartMotion = fullTextLower.includes('smartmotionhuman');
                    const isVideoMotion = fullTextLower.includes('videomotion');
                    const isAlarmeGen = fullTextLower.includes('alarme');
                    const isAlarme = isAlarmeGen || isSmartMotion || isVideoMotion;

                    let tituloEvento = tipoEvento;
                    if (tipoEvento === 'Camera Agent DVR Alarme') {
                        tituloEvento = 'Alarme em Câmera';
                    }

                    if (isSmartMotion) {
                        tituloEvento = '🚨 Alarme: SmartMotionHuman';
                    } else if (isVideoMotion) {
                        tituloEvento = '🚨 Alarme: VideoMotion';
                    } else if (isAlarmeGen && !tituloEvento.toLowerCase().includes('alarme')) {
                        tituloEvento = '🚨 Alarme: ' + tituloEvento;
                    }

                    let color = '#f8fafc';
                    let fontColor = '#334155';
                    let Icon = <WarningAmberIcon fontSize="small" />;
                    
                    if (isAlarme) {
                        color = '#fee2e2';
                        fontColor = '#991b1b';
                        Icon = <NotificationsActiveIcon fontSize="small" style={{ color: '#dc2626' }} />;
                    } else if (fullTextLower.includes('armar') || fullTextLower.includes('armada')) {
                        color = '#dcfce7';
                        fontColor = '#166534';
                        Icon = <LockIcon fontSize="small" style={{ color: '#16a34a' }} />;
                    } else if (fullTextLower.includes('desarmar') || fullTextLower.includes('desarmada') || fullTextLower.includes('desativar')) {
                        color = '#fef3c7';
                        fontColor = '#92400e';
                        Icon = <LockOpenIcon fontSize="small" style={{ color: '#d97706' }} />;
                    } else if (fullTextLower.includes('facial') || fullTextLower.includes('pessoa') || pessoa !== '') {
                        color = '#e0e7ff';
                        fontColor = '#3730a3';
                        Icon = <FaceIcon fontSize="small" style={{ color: '#4f46e5' }} />;
                    }

                    return (
                        <div style={{ 
                            fontSize: '11px', 
                            lineHeight: '1.4', 
                            backgroundColor: color, 
                            color: fontColor, 
                            padding: '6px 8px', 
                            borderRadius: '6px',
                            border: `1px solid ${fontColor}44`,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '4px',
                            boxShadow: isAlarme ? '0 1px 3px rgba(220,38,38,0.15)' : 'none'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: '700', fontSize: '11.5px' }}>
                                {Icon} {tituloEvento}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '10.5px' }}>
                                <div><b>IP:</b> {ipDispositivo}</div>
                                {idEquipamento !== 'N/A' && <div><b>ID:</b> {idEquipamento}</div>}
                                <div><b>Disp:</b> {tipoDispositivo}</div>
                                {nomeZona !== 'N/A' && <div><b>Zona:</b> {nomeZona}</div>}
                                {pessoa && <div><b>Pessoa:</b> {pessoa}</div>}
                            </div>
                        </div>
                    );
                }
            },
            {
                accessorKey: 'origem',
                header: 'Origem',
                size: 70,
            },
            {
                accessorKey: 'info_extra',
                header: 'Info Extra',
                size: 60,
                Cell: ({ row }) => {
                    const original = row.original;
                    if (original.valor_string2) {
                        return (
                            <Tooltip
                                title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: '11px', maxWidth: '400px' }}>{original.valor_string2}</pre>}
                                arrow
                                placement="left"
                                slotProps={{ popper: { style: { zIndex: 200000 } } }}
                            >
                                <span style={{ cursor: 'pointer', color: '#3b82f6', textDecoration: 'underline', fontSize: '12px', fontWeight: 'bold' }}>Ver Info</span>
                            </Tooltip>
                        );
                    }
                    return null;
                }
            },
            {
                id: 'evento_integracao',
                header: 'Evento Integração',
                size: 80,
                Cell: ({ row }) => {
                    const original = row.original;
                    const sigma = original.tarefa_sigma;
                    if (sigma) {
                        return (
                            <span
                                style={{
                                    cursor: 'pointer',
                                    color: '#1d4ed8',
                                    fontWeight: 700,
                                    fontSize: '11px',
                                    textDecoration: 'underline',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    backgroundColor: '#eff6ff',
                                    border: '1px solid #bfdbfe',
                                    display: 'inline-block'
                                }}
                                title="Clique para ver detalhes do evento enviado ao Segware Sigma"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleAbrirModalSigma(sigma, original);
                                }}
                            >
                                Info
                            </span>
                        );
                    }
                    return null;
                }
            },
            {
                id: 'video_fase_1',
                header: 'Vídeo 1',
                size: 65,
                Cell: ({ row }) => {
                    const original = row.original;
                    if (original.url_video_imediato) {
                        return (
                            <IconButton
                                color="secondary"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedAlarmeRow(original);
                                    const url = processVideoUrl(original.url_video_imediato);
                                    if (url) {
                                        setSelectedAlarmeVideoUrls([url]);
                                        setOpenAlarmeVideo(true);
                                    }
                                }}
                            >
                                <PlayCircleOutlineIcon fontSize="medium" style={{ color: '#dc2626' }} />
                            </IconButton>
                        );
                    }
                    return <span style={{ fontSize: '10px', color: 'gray' }}>Sem Vídeo</span>;
                }
            },
            {
                id: 'video_fase_2',
                header: 'Vídeo 2',
                size: 65,
                Cell: ({ row }) => {
                    const original = row.original;
                    if (original.url_video_completo) {
                        return (
                            <IconButton
                                color="secondary"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedAlarmeRow(original);
                                    const url = processVideoUrl(original.url_video_completo);
                                    if (url) {
                                        setSelectedAlarmeVideoUrls([url]);
                                        setOpenAlarmeVideo(true);
                                    }
                                }}
                            >
                                <PlayCircleOutlineIcon fontSize="medium" style={{ color: '#dc2626' }} />
                            </IconButton>
                        );
                    }
                    return <span style={{ fontSize: '10px', color: 'gray' }}>Sem Vídeo</span>;
                }
            },
            {
                id: 'imagem_intrusao',
                header: 'Imagem',
                size: 65,
                Cell: ({ row }) => {
                    const original = row.original;
                    if (original.imagem_intrusao) {
                        return (
                            <IconButton
                                color="secondary"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedAlarmeRow(original);
                                    const url = processVideoUrl(original.imagem_intrusao);
                                    if (url) {
                                        setSelectedAlarmeImageUrls([url]);
                                        setOpenAlarmeImage(true);
                                    }
                                }}
                            >
                                <PlayCircleOutlineIcon fontSize="medium" style={{ color: '#3b82f6' }} />
                            </IconButton>
                        );
                    }
                    return <span style={{ fontSize: '10px', color: 'gray' }}>Sem Imagem</span>;
                }
            },
        ],
        [],
    );



    // const link =
    //"https://gruporosinetos.com/call/softphone.html?wp_serveraddress=gruporosinetos.com&wp_username=webrtc&wp_password=1234&wp_callto=2024111&wp_autoaction=1";

    const link =
        "https://gruporosinetos.com/call/softphone.html?wp_serveraddress=gruporosinetos.com&wp_username=webrtc&wp_password=1234&wp_callto=2024111&wp_autoaction=1";


    const openLinkInNewTab = () => {
        window.open(link, "_blank"); // Abre em uma nova guia
    };

    async function handleClickLogDuplicated() {
        // This was a duplicated function block, replaced to avoid collision
    }

    async function handleClickPgm(rele, comando) {

        console.log("handleClickPgm")
        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = `/v1/protected/modulosonoro/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_sonoro.id_modulo_sonoro + "/" + comando + "/" + rele + "/0/0/0/0/0/0/0";
            const response = await api.get(url, { headers });

            if (response.data) {
                setSnackbarMessage('Comando Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);


            }



        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando: ' + error);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }

    async function handleClickArmacao(modo) {
        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const endpoint = modo === 1 ? 'armar_unifier' : 'desarmar_unifier';
            const url = `/v1/protected/modulosonoro/${endpoint}/${equipamento.modulo_sonoro.id_modulo_sonoro}`;
            const usuarioNome = Cookies.get("nome_amigavel") || Cookies.get("usuario") || Cookies.get("login") || "";
            const response = await api.post(url, { usuario: usuarioNome }, { headers });

            if (response.status === 200) {
                setSnackbarMessage(modo === 1 ? 'Comando de Arme Enviado!' : 'Comando de Desarme Enviado!');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage('Erro ao enviar comando: ' + error);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error("Erro ao enviar o comando:", error);
        }
    }

    const processarIndexAtivarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 1;
        } else if (index === 2) {
            //rele 2
            return 2;
        } else if (index === 3) {
            //rele 3
            return 3;
        } else if (index === 4) {
            //rele 4
            return 4;
        } else if (index === 5) {
            //rele 5
            return 5;
        }
    }

    const processarIndexDesativarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 1;
        } else if (index === 2) {
            //rele 2
            return 2;
        } else if (index === 3) {
            //rele 3
            return 3;
        } else if (index === 4) {
            //rele 4
            return 4;
        } else if (index === 5) {
            //rele 5
            return 5;
        }
    }

    // Calcular a diferença de tempo
    const now = new Date();
    const lastResponse = new Date(equipamento.modulo_sonoro.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

    // Verificar se o alarme deve ser ativado
    const alarme = equipamento.alarme;

    // Definir o estado do equipamento
    let statusText;
    let statusColor;
    let isBlinking = false;

    const tipoArmacao = equipamento.modulo_sonoro.tipo_armacao;
    const isArmada = equipamento.modulo_sonoro.armada; // Alguns payloads como websocket podem usar armada

    // Fallback caso a API websocket não envie tipo_armacao
    let isZoneArmed = false;
    if (equipamento.modulo_sonoro.status_zonas) {
        isZoneArmed = equipamento.modulo_sonoro.status_zonas.split(";").some(l => {
            const p = l.split(",");
            if (p.length < 4) return false;
            const s = (p[3] || "").toLowerCase().trim();
            return s === "armada" || s === "true" || s === "1";
        });
    }

    if (alarme) {
        statusText = "ALARME";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver em alarme
    } else if (differenceInMinutes < tempoInativo) {
        if (tipoArmacao == 1 || tipoArmacao === true || String(tipoArmacao) === "1" || isArmada === true || String(isArmada) === "1" || isZoneArmed) {
            statusText = "MÓDULO SONORO ARMADO LOCALMENTE";
            statusColor = "green";
        }
        else {
            statusText = "MÓDULO SONORO DESARMADO LOCALMENTE";
            statusColor = "orange";
        }
    } else {
        statusText = "OFFLINE";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver offline
    }




    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            align="center"
            item xs={flag === 0 ? 3 : 12}
            style={{ border: flag === 1 ? 'none' : null, padding: 0, margin: flag === 1 ? '8px 0' : 0 }}
        >
            {flag === 1 && (
                <div style={{
                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                    borderRadius: '16px',
                    padding: '24px',
                    width: '100%',
                    fontFamily: '"Rajdhani", "Roboto", "Segoe UI", sans-serif',
                    boxShadow: darkMode ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.08)',
                    border: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                }}>
                    {/* HEADER IOT */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0', paddingBottom: '16px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <SettingsInputComponentIcon style={{ fontSize: 48, position: 'relative', zIndex: 2, color: darkMode ? '#f8fafc' : '#0f172a' }} />
                                <div style={{
                                    position: 'absolute', width: '56px', height: '56px', borderRadius: '50%',
                                    backgroundColor: '#3b82f6', opacity: 0.2, animation: 'pulse 2s infinite', zIndex: 1
                                }} />
                            </div>
                            <div style={{ textAlign: 'left' }}>
                                <Typography style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.5px', color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1.2 }}>
                                    NÚCLEO UNIFIER <span style={{ color: '#3b82f6', fontSize: '0.8rem', backgroundColor: 'rgba(59, 130, 246, 0.1)', padding: '2px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px' }}>UNIFIER CORE</span>
                                </Typography>
                                <Typography style={{ fontSize: '0.85rem', color: darkMode ? '#94a3b8' : '#64748b', fontFamily: 'monospace', marginTop: '4px' }}>
                                    UUID: {equipamento.modulo_sonoro.codigo} | Última resposta: {moment(equipamento.modulo_sonoro.data_hora_ultima_resposta).format('HH:mm:ss DD/MM/YYYY')} | Modelo: {equipamento.modulo_sonoro.modelo || "Unifier"} | Versão: {equipamento.modulo_sonoro.firmware_version || "N/A"}
                                    <br />
                                    STATUS:
                                    <Tooltip title="Quando o Módulo Sonoro está ARMADO, ele aceita receber os eventos de detecção das câmeras e tocará a sirene automaticamente." placement="top" arrow>
                                        <span style={{ color: statusColor, fontWeight: 'bold', marginLeft: '4px', cursor: 'help' }}>{statusText}</span>
                                    </Tooltip>
                                </Typography>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <IconButton
                                onClick={handleMenuClick}
                                size="small"
                                style={{
                                    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                    color: darkMode ? '#94a3b8' : '#64748b',
                                    border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    transition: 'all 0.2s',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.color = darkMode ? '#f8fafc' : '#0f172a'; }}
                                onMouseOut={(e) => { e.currentTarget.style.borderColor = darkMode ? '#334155' : '#e2e8f0'; e.currentTarget.style.color = darkMode ? '#94a3b8' : '#64748b'; }}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={handleMenuClose}
                                PaperProps={{
                                    style: {
                                        backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                        color: darkMode ? '#f8fafc' : '#0f172a',
                                        border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                        boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                                        minWidth: '220px'
                                    }
                                }}
                            >
                                <MenuItem
                                    onClick={() => acessarMonitor(equipamento.modulo_sonoro.url_monitor)}
                                    style={{ fontSize: '0.85rem', fontWeight: 600, padding: '10px 20px' }}
                                >
                                    <ListItemIcon><MonitorIcon fontSize="small" style={{ color: 'green' }} /></ListItemIcon>
                                    ACESSAR MONITOR
                                </MenuItem>
                                <MenuItem
                                    onClick={() => acessoRemoto(equipamento.modulo_sonoro.url_vnc_web)}
                                    style={{ fontSize: '0.85rem', fontWeight: 600, padding: '10px 20px' }}
                                >
                                    <ListItemIcon><VpnKeyIcon fontSize="small" style={{ color: 'orange' }} /></ListItemIcon>
                                    ACESSO REMOTO
                                </MenuItem>
                                <MenuItem
                                    onClick={() => acessoSshRemoto(equipamento.modulo_sonoro.url_ssh_web)}
                                    style={{ fontSize: '0.85rem', fontWeight: 600, padding: '10px 20px' }}
                                >
                                    <ListItemIcon><TerminalIcon fontSize="small" style={{ color: 'purple' }} /></ListItemIcon>
                                    SSH REMOTO
                                </MenuItem>
                                <MenuItem
                                    onClick={() => acessoSshRemoto(equipamento.modulo_sonoro.url_ping_rede)}
                                    style={{ fontSize: '0.85rem', fontWeight: 600, padding: '10px 20px' }}
                                >
                                    <ListItemIcon><LanIcon fontSize="small" style={{ color: 'black' }} /></ListItemIcon>
                                    ESTADO DA REDE
                                </MenuItem>
                                <MenuItem
                                    onClick={handleMenuToggleRotas}
                                    style={{ fontSize: '0.85rem', fontWeight: 600, padding: '10px 20px', borderTop: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', marginTop: '4px' }}
                                >
                                    <ListItemIcon><DeviceHubIcon fontSize="small" style={{ color: '#3b82f6' }} /></ListItemIcon>
                                    ACESSO VIA ROTA (AVANÇADO)
                                </MenuItem>
                            </Menu>

                            <button
                                onClick={() => setOpenReproducao(true)}
                                style={{
                                    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                    color: darkMode ? '#60a5fa' : '#3b82f6',
                                    border: darkMode ? '1px solid #3b82f6' : '1px solid #bfdbfe',
                                    borderRadius: '8px', padding: '6px 16px', fontSize: '0.85rem', cursor: 'pointer', fontWeight: 800,
                                    textTransform: 'uppercase', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '6px',
                                    boxShadow: '0 2px 4px rgba(59, 130, 246, 0.1)',
                                    height: '38px'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#3b82f6'; e.currentTarget.style.color = '#ffffff'; }}
                                onMouseOut={(e) => { e.currentTarget.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff'; e.currentTarget.style.color = darkMode ? '#60a5fa' : '#3b82f6'; }}
                            >
                                <img src={icone_corneta} alt="Audio" style={{ width: 16, height: 16, filter: 'brightness(2)' }} />
                                ÁUDIO
                            </button>
                            <button
                                onClick={handleOpenVideoAgent}
                                style={{
                                    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                    color: darkMode ? '#ef4444' : '#dc2626',
                                    border: darkMode ? '1px solid #ef4444' : '1px solid #fca5a5',
                                    borderRadius: '8px', padding: '6px 16px', fontSize: '0.85rem', cursor: 'pointer', fontWeight: 800,
                                    textTransform: 'uppercase', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '6px',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)',
                                    height: '38px', marginLeft: '10px'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#dc2626'; e.currentTarget.style.color = '#ffffff'; }}
                                onMouseOut={(e) => { e.currentTarget.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff'; e.currentTarget.style.color = darkMode ? '#ef4444' : '#dc2626'; }}
                            >
                                <MonitorIcon fontSize="small" style={{ marginBottom: 2 }} />
                                VÍDEO
                            </button>
                            <button
                                onClick={() => handleClickLog()}
                                style={{
                                    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                    color: darkMode ? '#94a3b8' : '#64748b',
                                    border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                    borderRadius: '8px', padding: '6px 16px', fontSize: '0.85rem', cursor: 'pointer', fontWeight: 800,
                                    textTransform: 'uppercase', transition: 'all 0.2s',
                                    height: '38px'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#94a3b8'; e.currentTarget.style.color = darkMode ? '#f8fafc' : '#0f172a'; }}
                                onMouseOut={(e) => { e.currentTarget.style.borderColor = darkMode ? '#334155' : '#e2e8f0'; e.currentTarget.style.color = darkMode ? '#94a3b8' : '#64748b'; }}
                            >
                                REGISTROS
                            </button>
                        </div>
                    </div>

                    {/* ARM/DISARM PANEL */}
                    <div style={{
                        backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', padding: '16px', marginBottom: '16px',
                        border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                backgroundColor: tipoArmacao === 1 ? (darkMode ? 'rgba(16, 185, 129, 0.2)' : 'rgba(16, 185, 129, 0.1)') : (darkMode ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.1)'),
                                padding: '10px', borderRadius: '50%', display: 'flex'
                            }}>
                                {tipoArmacao === 1 ? <LockIcon style={{ color: '#10b981' }} /> : <LockOpenIcon style={{ color: '#f59e0b' }} />}
                            </div>
                            <div>
                                <Typography style={{ fontWeight: 800, fontSize: '1rem', color: darkMode ? '#f8fafc' : '#0f172a' }}>
                                    CONTROLE DE ARMAÇÃO DO MÓDULO SONORO
                                </Typography>
                                <Typography style={{ fontSize: '0.75rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                    Define se a corneta tocará automaticamente ao receber requisições de alarme das câmeras.
                                </Typography>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button
                                onClick={() => handleClickArmacao(1)}
                                disabled={tipoArmacao === 1}
                                style={{
                                    backgroundColor: tipoArmacao === 1 ? (darkMode ? '#334155' : '#e2e8f0') : (darkMode ? '#1e293b' : '#ffffff'),
                                    color: tipoArmacao === 1 ? (darkMode ? '#94a3b8' : '#94a3b8') : (darkMode ? '#10b981' : '#059669'),
                                    border: tipoArmacao === 1 ? (darkMode ? '1px solid #475569' : '1px solid #cbd5e1') : (darkMode ? '1px solid #10b981' : '1px solid #34d399'),
                                    borderRadius: '8px', padding: '8px 24px', fontSize: '0.85rem', fontWeight: 800,
                                    textTransform: 'uppercase', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '8px',
                                    cursor: tipoArmacao === 1 ? 'not-allowed' : 'pointer',
                                    boxShadow: tipoArmacao === 1 ? 'none' : '0 2px 4px rgba(16, 185, 129, 0.1)',
                                }}
                                onMouseOver={(e) => { if (tipoArmacao !== 1) { e.currentTarget.style.backgroundColor = '#10b981'; e.currentTarget.style.color = '#ffffff'; } }}
                                onMouseOut={(e) => { if (tipoArmacao !== 1) { e.currentTarget.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff'; e.currentTarget.style.color = darkMode ? '#10b981' : '#059669'; } }}
                            >
                                <LockIcon fontSize="small" />
                                ARMAR
                            </button>
                            <button
                                onClick={() => handleClickArmacao(0)}
                                disabled={tipoArmacao === 0}
                                style={{
                                    backgroundColor: tipoArmacao === 0 ? (darkMode ? '#334155' : '#e2e8f0') : (darkMode ? '#1e293b' : '#ffffff'),
                                    color: tipoArmacao === 0 ? (darkMode ? '#94a3b8' : '#94a3b8') : (darkMode ? '#f59e0b' : '#d97706'),
                                    border: tipoArmacao === 0 ? (darkMode ? '1px solid #475569' : '1px solid #cbd5e1') : (darkMode ? '1px solid #f59e0b' : '1px solid #fbbf24'),
                                    borderRadius: '8px', padding: '8px 24px', fontSize: '0.85rem', fontWeight: 800,
                                    textTransform: 'uppercase', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '8px',
                                    cursor: tipoArmacao === 0 ? 'not-allowed' : 'pointer',
                                    boxShadow: tipoArmacao === 0 ? 'none' : '0 2px 4px rgba(245, 158, 11, 0.1)',
                                }}
                                onMouseOver={(e) => { if (tipoArmacao !== 0) { e.currentTarget.style.backgroundColor = '#f59e0b'; e.currentTarget.style.color = '#ffffff'; } }}
                                onMouseOut={(e) => { if (tipoArmacao !== 0) { e.currentTarget.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff'; e.currentTarget.style.color = darkMode ? '#f59e0b' : '#d97706'; } }}
                            >
                                <LockOpenIcon fontSize="small" />
                                DESARMAR
                            </button>
                        </div>
                    </div>

                    {/* TELEMETRY & CONNECTIVITY ROW */}
                    <div style={{
                        backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', padding: '12px 20px', marginBottom: '24px',
                        border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-around', alignItems: 'center',
                        boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                    }}>
                        {/* Power */}
                        <Tooltip
                            PopperProps={{
                                sx: {
                                    zIndex: 11000
                                }
                            }}
                            title={equipamento.modulo_sonoro.tensao >= 1 ? 'AC Detectado' : 'Sem Tensão AC'} arrow placement="top">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', opacity: equipamento.modulo_sonoro.tensao >= 1 ? 1 : 0.5 }}>
                                <img src={equipamento.modulo_sonoro.tensao >= 1 ? tensao_ac : sem_tensao} alt="Power" style={{ width: 28, height: 28 }} />
                                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: darkMode ? '#94a3b8' : '#64748b' }}>ENERGIA</span>
                            </div>
                        </Tooltip>

                        {/* Network Wifi */}
                        <Tooltip
                            PopperProps={{
                                sx: {
                                    zIndex: 11000
                                }
                            }}
                            title={equipamento.modulo_sonoro.conectado_wifi?.includes("wifi_conectado") ? 'WiFi Conectado' : 'WiFi Desconectado'} arrow placement="top">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', opacity: equipamento.modulo_sonoro.conectado_wifi?.includes("wifi_conectado") ? 1 : 0.5 }}>
                                <img src={equipamento.modulo_sonoro.conectado_wifi?.includes("wifi_conectado") ? wifi_conectado : wifi_desconectado} alt="Wifi" style={{ width: 28, height: 28 }} />
                                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: darkMode ? '#94a3b8' : '#64748b' }}>WIFI</span>
                            </div>
                        </Tooltip>

                        {/* Network Eth */}
                        <Tooltip
                            PopperProps={{
                                sx: {
                                    zIndex: 11000
                                }
                            }}
                            title={equipamento.modulo_sonoro.conectado_eth?.includes("cabo_conectado") ? 'Eth Conectado' : 'Eth Desconectado'} arrow placement="top">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', opacity: equipamento.modulo_sonoro.conectado_eth?.includes("cabo_conectado") ? 1 : 0.5 }}>
                                <img src={equipamento.modulo_sonoro.conectado_eth?.includes("cabo_conectado") ? cabo_conectado : cabo_desconectado} alt="Eth" style={{ width: 28, height: 28 }} />
                                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: darkMode ? '#94a3b8' : '#64748b' }}>REDE (ETH)</span>
                            </div>
                        </Tooltip>

                        {/* Network Modem */}
                        <Tooltip
                            PopperProps={{
                                sx: {
                                    zIndex: 11000
                                }
                            }}
                            title={equipamento.modulo_sonoro.conectado_gsm?.includes("modem_conectado") ? 'Modem Conectado' : 'Modem Desconectado'} arrow placement="top">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', opacity: equipamento.modulo_sonoro.conectado_gsm?.includes("modem_conectado") ? 1 : 0.5 }}>
                                <img src={equipamento.modulo_sonoro.conectado_gsm?.includes("modem_conectado") ? modem_conectado : modem_desconectado} alt="Modem" style={{ width: 28, height: 28 }} />
                                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: darkMode ? '#94a3b8' : '#64748b' }}>MODEM (GSM)</span>
                            </div>
                        </Tooltip>

                        {/* Internet Source Indicator */}
                        <Tooltip
                            PopperProps={{
                                sx: {
                                    zIndex: 11000
                                }
                            }}
                            title="Fonte de Internet Ativa" arrow placement="top">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                                <img src={
                                    equipamento.modulo_sonoro.conectado_eth?.includes("internet_cabo") ? cabo_internet :
                                        equipamento.modulo_sonoro.conectado_wifi?.includes("internet_wifi") ? wifi_internet :
                                            equipamento.modulo_sonoro.conectado_gsm?.includes("internet_modem") ? modem_internet :
                                                cabo_sem_internet
                                } alt="Internet" style={{ width: 28, height: 28 }} />
                                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: '#10b981' }}>NUVEM</span>
                            </div>
                        </Tooltip>
                    </div>

                    <Grid container spacing={3}>
                        {/* LEFT COLUMN: CONTROLS & SIP */}
                        <Grid item xs={12} md={7}>
                            <Grid container spacing={3}>
                                {/* RELAYS */}
                                <Grid item xs={12}>
                                    <div style={{
                                        backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', overflow: 'hidden',
                                        boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                                    }}>
                                        <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <PowerSettingsNewIcon fontSize="small" /> CANAIS DE ATUAÇÃO
                                        </div>
                                        <div style={{ padding: '16px' }}>
                                            <Grid container spacing={2}>
                                                {[1, 2, 3, 4, 5].map((index) => {
                                                    const releNome = equipamento?.modulo_sonoro[`nome_rele${index}`] || `Relé ${index}`;
                                                    const status = equipamento?.modulo_sonoro[`status_rele${index}`];
                                                    const isOn = status === "on";

                                                    return (
                                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                                            <div style={{
                                                                backgroundColor: isOn ? (darkMode ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.05)') : (darkMode ? '#0f172a' : '#f8fafc'),
                                                                border: isOn ? '1px solid #10b981' : (darkMode ? '1px solid #334155' : '1px solid #e2e8f0'),
                                                                borderRadius: '8px', padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'all 0.3s'
                                                            }}>
                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <span style={{ fontSize: '0.65rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 800, letterSpacing: '0.5px' }}>CAN. {index}</span>
                                                                    <span style={{ fontSize: '0.9rem', color: darkMode ? '#f8fafc' : '#0f172a', fontWeight: 700 }}>{releNome}</span>
                                                                </div>
                                                                <Switch
                                                                    checked={isOn}
                                                                    onChange={(e) => {
                                                                        if (isOn) {
                                                                            handleClickPgm(processarIndexDesativarRele(index), 11);
                                                                        } else {
                                                                            handleClickPgm(processarIndexAtivarRele(index), 10);
                                                                        }
                                                                    }}
                                                                    color="success"
                                                                />
                                                            </div>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>

                                {/* SIP COMPONENT */}
                                <Grid item xs={12}>
                                    <div style={{
                                        backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', overflow: 'hidden',
                                        display: 'flex', flexDirection: 'column'
                                    }}>
                                        <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><CallIcon fontSize="small" /> INTERFONE SIP </span>
                                            <span style={{ color: sipStatus === 'Registered' ? '#10b981' : '#f59e0b', fontSize: '0.7rem' }}>{sipStatus === 'Registered' ? 'REGISTRADO' : (sipStatus || 'AGUARDANDO')}</span>
                                        </div>
                                        <div style={{ padding: '16px', flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <SipCallComponent
                                                ramal={equipamento.ramal || 'unknown'}
                                                status={sipStatus}
                                                isCalling={activeCallRamal === equipamento.ramal}
                                                onCall={onSipCall}
                                                onHangup={onSipHangup}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* RIGHT COLUMN: SYSTEM STATUS */}
                        <Grid item xs={12} md={5}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                borderRadius: '12px',
                                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%',
                                position: 'relative',
                                display: 'flex', flexDirection: 'column'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '12px 12px 0 0' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><SensorsIcon fontSize="small" /> STATUS DO SISTEMA </span>
                                </div>
                                <div style={{ padding: '16px', flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Grid container spacing={2} style={{ height: '100%' }}>
                                        <Grid item xs={6}>
                                            <Tooltip
                                                PopperProps={{
                                                    sx: {
                                                        zIndex: 11000
                                                    }
                                                }}
                                                title={
                                                    <div style={{ backgroundColor: darkMode ? '#1e293b' : 'white', minHeight: "300px", minWidth: "400px", maxHeight: "300px", maxWidth: "400px", border: darkMode ? '1px solid #334155' : '1px solid black', color: darkMode ? '#f8fafc' : 'black', overflow: "auto" }}>
                                                        <Grid container direction="row" item xs={12} alignItems="center" justifyContent="flex-start">
                                                            <Typography style={{ padding: 1 }}>
                                                                <Box sx={{ whiteSpace: "pre-line" }}>
                                                                    <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px', color: '#1976d2' }}>
                                                                        Atualizado em {moment(equipamento.modulo_sonoro.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} ({moment(equipamento.modulo_sonoro.data_hora_status_zona, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                                    </span>
                                                                    {equipamento.modulo_sonoro.status_zonas && equipamento.modulo_sonoro.status_zonas
                                                                        .split(";")
                                                                        .filter(Boolean)
                                                                        .map((linha) => {
                                                                            const [id, nome, zoneStatus, armeStatus, zoneAlarme] = linha.split(",");
                                                                            return (
                                                                                <Zone
                                                                                    key={id}
                                                                                    zoneData={{
                                                                                        id,
                                                                                        nome,
                                                                                        zoneStatus,
                                                                                        armeStatus,
                                                                                        zoneAlarme,
                                                                                    }}
                                                                                />
                                                                            );
                                                                        })}
                                                                </Box>
                                                            </Typography>
                                                        </Grid>
                                                    </div>
                                                } placement="top" arrow>
                                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', height: '100%', minHeight: '120px', transition: 'all 0.2s', padding: '16px' }}>
                                                    <SensorsIcon style={{ fontSize: '40px', color: '#3b82f6' }} />
                                                    <Typography style={{ fontSize: '0.85rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#0f172a', letterSpacing: '1px' }}>ZONAS</Typography>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Tooltip
                                                PopperProps={{
                                                    sx: {
                                                        zIndex: 11000
                                                    }
                                                }}
                                                title={
                                                    <div style={{ backgroundColor: darkMode ? '#1e293b' : 'white', minHeight: '300px', minWidth: '400px', border: darkMode ? '1px solid #334155' : '1px solid black', color: darkMode ? '#f8fafc' : 'black' }}>
                                                        <Grid container direction="row" item xs={12} alignItems="center" justifyContent="flex-start">
                                                            <Typography style={{ padding: 1 }}>
                                                                <Box sx={{ whiteSpace: 'pre-line', padding: '10px' }}>
                                                                    <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px', color: '#9c27b0' }}>
                                                                        Atualizado em {moment(equipamento.modulo_sonoro.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")} ({moment(equipamento.modulo_sonoro.data_hora_status_particao, "YYYY-MM-DD HH:mm:ss").fromNow()})
                                                                    </span>
                                                                    <span>{equipamento.modulo_sonoro.status_central}</span>
                                                                </Box>
                                                            </Typography>
                                                        </Grid>
                                                    </div>
                                                } placement="top" arrow>
                                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', height: '100%', minHeight: '120px', transition: 'all 0.2s', padding: '16px' }}>
                                                    <AccountTreeIcon style={{ fontSize: '40px', color: '#8b5cf6' }} />
                                                    <Typography style={{ fontSize: '0.85rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#0f172a', letterSpacing: '1px' }}>PARTIÇÕES</Typography>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            )}

            {flag === 0 && (
                <Grid container direction="row" justifyContent="center" align="center" item xs={12} style={{ boxShadow: alarme ? `0 0 30px 150px rgba(255, 0, 0, 0.5)` : "none" }}>
                    <Grid item xs={12}>
                        <VolumeUpIcon style={{ fontSize: 36, color: darkMode ? '#3b82f6' : '#2563eb' }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Tooltip title={
                            <Typography style={{ padding: 1, fontSize: '12px' }}>
                                Última conexão: {moment(equipamento.modulo_sonoro.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}
                            </Typography>
                        } placement="top" arrow>
                            <span style={{ color: darkMode ? '#f8fafc' : '#0f172a', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' }}>{equipamento.modulo_sonoro.codigo} </span>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12}>
                        <span style={{ color: statusColor, fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', animation: isBlinking ? 'blink 2s step-start infinite' : 'none' }}>
                            {statusText}
                        </span>
                    </Grid>
                </Grid>
            )}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',

                    }
                }}
            />







            <Dialog style={{ zIndex: 210000 }} open={openReproducao} onClose={handleCloseReproducao}
                PaperProps={{ style: { minWidth: '80%', minHeight: '80%' } }}
            >
                <DialogTitle>Painel de Aúdio</DialogTitle>
                <DialogContent>
                    <ConfiguracoesReproducao
                        equipamento={equipamento} />
                </DialogContent>
            </Dialog>



            {/* Modal */}
            {openLogTable && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.75)",
                        zIndex: 199999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backdropFilter: "blur(4px)"
                    }}
                >
                    <div
                        style={{
                            width: "95vw",
                            height: "92vh",
                            backgroundColor: "#ffffff",
                            borderRadius: "12px",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            border: "1px solid #e2e8f0"
                        }}
                    >
                        {/* Modal Header */}
                        <div
                            style={{
                                backgroundColor: "#0f172a",
                                color: "#ffffff",
                                padding: "12px 20px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #1e293b"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <NotificationsActiveIcon style={{ color: "#38bdf8", fontSize: "22px" }} />
                                <span style={{ fontSize: "16px", fontWeight: "700", letterSpacing: "0.3px" }}>
                                    Histórico de Eventos - Módulo Sonoro
                                </span>
                                <span
                                    style={{
                                        backgroundColor: "#1e293b",
                                        color: "#38bdf8",
                                        fontSize: "12px",
                                        padding: "2px 10px",
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        border: "1px solid #334155"
                                    }}
                                >
                                    {rowCount} registros
                                </span>
                            </div>
                            <button
                                onClick={() => setOpenLogTable(false)}
                                style={{
                                    backgroundColor: "#ef4444",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "6px 14px",
                                    cursor: "pointer",
                                    fontWeight: "700",
                                    fontSize: "13px",
                                    transition: "all 0.2s"
                                }}
                            >
                                ✕ Fechar
                            </button>
                        </div>

                        {/* Top Toolbar: Search & Action Buttons */}
                        <div
                            style={{
                                backgroundColor: "#f8fafc",
                                padding: "10px 16px",
                                borderBottom: "1px solid #e2e8f0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "10px"
                            }}
                        >
                            {/* Search Input */}
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, maxWidth: "450px" }}>
                                <TextField
                                    size="small"
                                    placeholder="🔍 Buscar por ID, usuário, evento, IP ou zona..."
                                    variant="outlined"
                                    value={customSearch}
                                    onChange={(e) => setCustomSearch(e.target.value)}
                                    fullWidth
                                    style={{ backgroundColor: "#ffffff" }}
                                />
                            </div>

                            {/* Export & Action Buttons */}
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => fetchLogsData()}
                                    startIcon={<RefreshIcon />}
                                    variant="contained"
                                >
                                    Atualizar
                                </Button>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={handleExportDataPDF}
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                >
                                    Exportar PDF
                                </Button>
                                <Button
                                    size="small"
                                    style={{ backgroundColor: '#10b981', color: 'white' }}
                                    onClick={handleExportDataExcel}
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                >
                                    Exportar Excel
                                </Button>
                            </div>
                        </div>

                        {/* Table Area */}
                        <div style={{ flex: 1, overflow: "auto", padding: 0 }}>
                            {isFetchingLogs ? (
                                <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>
                                    <Typography style={{ fontWeight: "600", fontSize: "15px" }}>Carregando histórico de eventos...</Typography>
                                </div>
                            ) : (
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13.5px", textAlign: "left" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f1f5f9", borderBottom: "2px solid #cbd5e1", position: "sticky", top: 0, zIndex: 10 }}>
                                            <th style={{ padding: "10px 12px", width: "50px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>ID</th>
                                            <th style={{ padding: "10px 12px", width: "110px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Usuário</th>
                                            <th style={{ padding: "10px 12px", width: "140px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Data Requisição</th>
                                            <th style={{ padding: "10px 12px", width: "140px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Data Resposta</th>
                                            <th style={{ padding: "10px 12px", width: "140px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Tipo</th>
                                            <th style={{ padding: "10px 12px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Evento</th>
                                            <th style={{ padding: "10px 12px", width: "90px", color: "#334155", fontWeight: "700", fontSize: "13px" }}>Origem</th>
                                            <th style={{ padding: "10px 12px", width: "70px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Info</th>
                                            <th style={{ padding: "10px 12px", width: "115px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Evento Integração</th>
                                            <th style={{ padding: "10px 12px", width: "65px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Vídeo 1</th>
                                            <th style={{ padding: "10px 12px", width: "65px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Vídeo 2</th>
                                            <th style={{ padding: "10px 12px", width: "65px", color: "#334155", fontWeight: "700", textAlign: "center", fontSize: "13px" }}>Imagem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredLogs.length === 0 ? (
                                            <tr>
                                                <td colSpan="12" style={{ padding: "30px", textAlign: "center", color: "#94a3b8", fontWeight: "600", fontSize: "14px" }}>
                                                    Nenhum evento encontrado.
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredLogs.map((row, idx) => {
                                                const logData = (row.valor_string || '') + ' ' + (row.valor_string2 || '');
                                                
                                                let rawTipoRequisicao = row.tipo_requisicao || '';
                                                if (rawTipoRequisicao === 'Camera Agent DVR Alarme' || rawTipoRequisicao === 'ALARME_CAMERA') {
                                                    rawTipoRequisicao = 'Alarme em Câmera';
                                                }

                                                let tipoEvento = rawTipoRequisicao || 'N/A';
                                                if (logData.includes('Tipo:')) {
                                                    const match = logData.match(/Tipo:\s*([^|]+)/);
                                                    if (match) tipoEvento = match[1].trim();
                                                }

                                                let ipDispositivo = row.origem || 'N/A';
                                                if (logData.includes('IP Câmera:')) {
                                                    const match = logData.match(/IP Câmera:\s*([^|]+)/);
                                                    if (match) ipDispositivo = match[1].trim();
                                                }

                                                let nomeZona = 'N/A';
                                                if (logData.includes('Zona:')) {
                                                    const match = logData.match(/Zona:\s*([^|]+)/);
                                                    if (match) nomeZona = match[1].trim();
                                                } else if (row.valor_string3 && row.valor_string3 !== 'null') {
                                                    nomeZona = row.valor_string3;
                                                }

                                                const fullTextLower = (tipoEvento + ' ' + logData + ' ' + (row.tipo_requisicao || '')).toLowerCase();
                                                const isSmartMotion = fullTextLower.includes('smartmotionhuman');
                                                const isVideoMotion = fullTextLower.includes('videomotion');
                                                const isAlarmeGen = fullTextLower.includes('alarme');
                                                const isAlarme = isAlarmeGen || isSmartMotion || isVideoMotion;

                                                let tituloEvento = tipoEvento;
                                                if (isSmartMotion) {
                                                    tituloEvento = '🚨 Alarme: SmartMotionHuman';
                                                } else if (isVideoMotion) {
                                                    tituloEvento = '🚨 Alarme: VideoMotion';
                                                } else if (isAlarmeGen && !tituloEvento.toLowerCase().includes('alarme')) {
                                                    tituloEvento = '🚨 Alarme: ' + tituloEvento;
                                                }

                                                const user = row.usuario_executor || row.usuario_executou || row.usuario_nome || row.nome_usuario || row.usuario || row.user_name || row.nome || (row.tarefa_sigma && row.tarefa_sigma.corpo_requisicao && row.tarefa_sigma.corpo_requisicao.includes('O usuario ') ? (row.tarefa_sigma.corpo_requisicao.match(/O usuario\s+([^ ]+(?:\s+[^ ]+)*?)\s+(?:armou|desarmou)/i) || [])[1] : null) || (extractEventString(row).includes('Pessoa:') ? (extractEventString(row).match(/Pessoa:\s*([^\n]+)/) || [])[1] : null) || '-';

                                                return (
                                                    <tr
                                                        key={row.id_tarefa || idx}
                                                        style={{
                                                            borderBottom: "1px solid #f1f5f9",
                                                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                                                            transition: "background 0.15s"
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? "#ffffff" : "#fafafa"}
                                                    >
                                                        {/* ID */}
                                                        <td style={{ padding: "8px 12px", fontWeight: "700", color: "#0f172a", fontSize: "13.5px" }}>
                                                            {row.id_tarefa}
                                                        </td>

                                                        {/* Usuário */}
                                                        <td style={{ padding: "8px 12px", fontWeight: "600", color: "#334155", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {user}
                                                        </td>

                                                        {/* Data Requisição */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {row.data_hora_requisicao || '-'}
                                                        </td>

                                                        {/* Data Resposta */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", whiteSpace: "nowrap", fontSize: "13px" }}>
                                                            {row.data_hora_resposta || '-'}
                                                        </td>

                                                        {/* Tipo */}
                                                        <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                                                            <span style={{
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                color: rawTipoRequisicao.toLowerCase().includes('alarme') ? "#dc2626" : "#475569",
                                                                backgroundColor: rawTipoRequisicao.toLowerCase().includes('alarme') ? "#fef2f2" : "#f1f5f9",
                                                                padding: "3px 8px",
                                                                borderRadius: "4px",
                                                                border: rawTipoRequisicao.toLowerCase().includes('alarme') ? "1px solid #fecaca" : "1px solid #e2e8f0"
                                                            }}>
                                                                {rawTipoRequisicao || '-'}
                                                            </span>
                                                        </td>

                                                        {/* Evento */}
                                                        <td style={{ padding: "8px 12px" }}>
                                                            <div style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                backgroundColor: isAlarme ? "#fee2e2" : "#f8fafc",
                                                                color: isAlarme ? "#991b1b" : "#334155",
                                                                border: `1px solid ${isAlarme ? "#fca5a5" : "#cbd5e1"}`,
                                                                padding: "4px 10px",
                                                                borderRadius: "6px",
                                                                fontSize: "12.5px",
                                                                fontWeight: isAlarme ? "700" : "500",
                                                                maxWidth: "100%"
                                                            }}>
                                                                {isAlarme && <NotificationsActiveIcon style={{ color: "#dc2626", fontSize: "16px" }} />}
                                                                <span>{tituloEvento}</span>
                                                                {ipDispositivo !== 'N/A' && <span style={{ color: "#64748b", fontWeight: "normal" }}>| IP: {ipDispositivo}</span>}
                                                                {nomeZona !== 'N/A' && <span style={{ color: "#64748b", fontWeight: "normal" }}>| Zona: {nomeZona}</span>}
                                                            </div>
                                                        </td>

                                                        {/* Origem */}
                                                        <td style={{ padding: "8px 12px", color: "#475569", fontSize: "13px" }}>
                                                            {row.origem || '-'}
                                                        </td>

                                                        {/* Info Extra */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.valor_string2 ? (
                                                                <Tooltip
                                                                    title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: "12px", maxWidth: '450px' }}>{row.valor_string2}</pre>}
                                                                    arrow
                                                                    placement="left"
                                                                >
                                                                    <span style={{ cursor: 'pointer', color: '#3b82f6', textDecoration: 'underline', fontSize: '12.5px', fontWeight: 'bold' }}>Ver</span>
                                                                </Tooltip>
                                                            ) : null}
                                                        </td>

                                                        {/* Evento Integração / Sigma */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.tarefa_sigma ? (
                                                                <span
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        color: '#1d4ed8',
                                                                        fontWeight: 700,
                                                                        fontSize: '11px',
                                                                        textDecoration: 'underline',
                                                                        padding: '3px 8px',
                                                                        borderRadius: '4px',
                                                                        backgroundColor: '#eff6ff',
                                                                        border: '1px solid #bfdbfe',
                                                                        display: 'inline-block'
                                                                    }}
                                                                    title="Clique para ver os detalhes da integração com o Segware Sigma"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleAbrirModalSigma(row.tarefa_sigma, row);
                                                                    }}
                                                                >
                                                                    Info
                                                                </span>
                                                            ) : null}
                                                        </td>

                                                        {/* Vídeo 1 */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.url_video_imediato ? (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedAlarmeRow(row);
                                                                        const url = processVideoUrl(row.url_video_imediato);
                                                                        if (url) {
                                                                            setSelectedAlarmeVideoUrls([url]);
                                                                            setOpenAlarmeVideo(true);
                                                                        }
                                                                    }}
                                                                >
                                                                    <PlayCircleOutlineIcon style={{ color: '#dc2626', fontSize: '22px' }} />
                                                                </IconButton>
                                                            ) : <span style={{ color: '#cbd5e1', fontSize: '11px' }}>-</span>}
                                                        </td>

                                                        {/* Vídeo 2 */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.url_video_completo ? (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedAlarmeRow(row);
                                                                        const url = processVideoUrl(row.url_video_completo);
                                                                        if (url) {
                                                                            setSelectedAlarmeVideoUrls([url]);
                                                                            setOpenAlarmeVideo(true);
                                                                        }
                                                                    }}
                                                                >
                                                                    <PlayCircleOutlineIcon style={{ color: '#dc2626', fontSize: '22px' }} />
                                                                </IconButton>
                                                            ) : <span style={{ color: '#cbd5e1', fontSize: '11px' }}>-</span>}
                                                        </td>

                                                        {/* Imagem */}
                                                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                                            {row.imagem_intrusao ? (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedAlarmeRow(row);
                                                                        const url = processVideoUrl(row.imagem_intrusao);
                                                                        if (url) {
                                                                            setSelectedAlarmeImageUrls([url]);
                                                                            setOpenAlarmeImage(true);
                                                                        }
                                                                    }}
                                                                >
                                                                    <PlayCircleOutlineIcon style={{ color: '#3b82f6', fontSize: '22px' }} />
                                                                </IconButton>
                                                            ) : <span style={{ color: '#cbd5e1', fontSize: '11px' }}>-</span>}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Pagination Footer */}
                        <div
                            style={{
                                backgroundColor: "#f8fafc",
                                padding: "10px 16px",
                                borderTop: "1px solid #e2e8f0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "13px",
                                color: "#475569"
                            }}
                        >
                            <div>
                                Exibindo <b>{filteredLogs.length}</b> de <b>{rowCount}</b> registros salvos
                            </div>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    Linhas por página:
                                    <select
                                        value={pagination.pageSize}
                                        onChange={(e) => {
                                            const newSize = Number(e.target.value);
                                            setPagination({ pageIndex: 0, pageSize: newSize });
                                            fetchLogsData(0, newSize);
                                        }}
                                        style={{ padding: "3px 6px", borderRadius: "4px", border: "1px solid #cbd5e1", fontSize: "12px" }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                    </select>
                                </label>

                                <div style={{ display: "flex", gap: "6px" }}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        disabled={pagination.pageIndex === 0}
                                        onClick={() => {
                                            const nextIndex = pagination.pageIndex - 1;
                                            setPagination(prev => ({ ...prev, pageIndex: nextIndex }));
                                            fetchLogsData(nextIndex, pagination.pageSize);
                                        }}
                                    >
                                        ◀ Anterior
                                    </Button>
                                    <span style={{ display: "flex", alignItems: "center", padding: "0 6px", fontWeight: "600" }}>
                                        Página {pagination.pageIndex + 1} de {Math.max(1, Math.ceil(rowCount / pagination.pageSize))}
                                    </span>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        disabled={(pagination.pageIndex + 1) * pagination.pageSize >= rowCount}
                                        onClick={() => {
                                            const nextIndex = pagination.pageIndex + 1;
                                            setPagination(prev => ({ ...prev, pageIndex: nextIndex }));
                                            fetchLogsData(nextIndex, pagination.pageSize);
                                        }}
                                    >
                                        Próxima ▶
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                style={{ zIndex: 9999 }}
                PaperProps={{
                    sx: {
                        width: "280px",
                        backgroundColor: darkMode ? '#0f172a' : '#ffffff',
                        color: darkMode ? '#f8fafc' : '#0f172a',
                        borderLeft: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                    },
                }}
            >
                <Box sx={{ padding: '24px' }}>
                    <Typography variant="h6" style={{ fontWeight: 800, marginBottom: '16px', fontSize: '1.1rem', color: '#3b82f6' }}>
                        ROTAS DE ACESSO
                    </Typography>
                    <Typography style={{ fontSize: '0.8rem', color: darkMode ? '#94a3b8' : '#64748b', marginBottom: '24px' }}>
                        Selecione uma rota para estabelecer uma conexão segura com o dispositivo.
                    </Typography>
                    <List>
                        {[...Array(10)].map((_, index) => {
                            const server = `Rota ${index + 1}`;
                            return (
                                <ListItem
                                    button
                                    key={server}
                                    onClick={() => criarRotaAcessoRemoto(equipamento, server)}
                                    style={{
                                        borderRadius: '8px',
                                        marginBottom: '8px',
                                        backgroundColor: darkMode ? 'rgba(59, 130, 246, 0.05)' : 'rgba(59, 130, 246, 0.02)',
                                        border: darkMode ? '1px solid rgba(59, 130, 246, 0.1)' : '1px solid rgba(59, 130, 246, 0.05)'
                                    }}
                                >
                                    <ListItemIcon>
                                        <DeviceHubIcon fontSize="small" style={{ color: '#3b82f6' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={server}
                                        primaryTypographyProps={{ style: { fontWeight: 700, fontSize: '0.9rem' } }}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>
            </Drawer>

            <Dialog
                open={openVideoAgent}
                onClose={() => setOpenVideoAgent(false)}
                maxWidth="xl"
                fullWidth
                style={{ zIndex: 210000 }}
                PaperProps={{ style: { height: '90vh' } }}
            >
                <DialogTitle style={{ backgroundColor: 'black', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Visualização Agent DVR
                    <Button onClick={() => setOpenVideoAgent(false)} style={{ color: 'white', minWidth: 'auto' }}>X</Button>
                </DialogTitle>
                <DialogContent style={{ padding: 0, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    {loadingVideo ? (
                        <Skeleton variant="rect" width="100%" height="100%" />
                    ) : (
                        urlAgentDVRFetch ? (
                            <iframe
                                src={urlAgentDVRFetch}
                                style={{ width: '100%', height: '100%', border: 'none' }}
                                title="Agent DVR View"
                            />
                        ) : (
                            <Typography style={{ padding: 20, textAlign: 'center', fontWeight: 'bold' }}>
                                URL do Agent DVR não configurada para este módulo no servidor.
                            </Typography>
                        )
                    )}
                </DialogContent>
            </Dialog>

            {/* Modal para Vídeo de Alarme (Tipo 90) */}
            <Modal
                open={openAlarmeVideo}
                onClose={() => setOpenAlarmeVideo(false)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 210001
                }}
            >
                {/* Container principal com dimensões travadas */}
                <Box
                    sx={{
                        width: "80vw",
                        height: "80vh",
                        bgcolor: "#000",
                        borderRadius: 1,
                        overflow: "hidden", // Garante zero vazamento de conteúdo
                        display: "flex",
                        flexDirection: "column",
                        outline: "none"
                    }}
                >
                    {/* Cabeçalho de altura fixa */}
                    <Box
                        sx={{
                            bgcolor: "#dc2626",
                            color: "#fff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            height: 56,
                            px: 2,
                            flexShrink: 0
                        }}
                    >
                        <Typography variant="h6" fontSize="1rem">
                            Gravação de Alarme - {selectedAlarmeRow?.data_hora_requisicao}
                        </Typography>

                        <Button
                            onClick={() => setOpenAlarmeVideo(false)}
                            sx={{ color: "#fff", minWidth: "auto", fontWeight: "bold" }}
                        >
                            X
                        </Button>
                    </Box>

                    {/* Área do vídeo ocupando 100% da altura restante */}
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            minHeight: 0
                        }}
                    >
                        {selectedAlarmeVideoUrls?.length ? (
                            <video
                                controls
                                autoPlay
                                src={selectedAlarmeVideoUrls[0]}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        ) : (
                            <Typography sx={{ color: "#fff" }}>
                                Nenhum vídeo disponível.
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Modal>

        <Modal
                open={openAlarmeImage}
                onClose={() => setOpenAlarmeImage(false)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 210001
                }}
            >
                <Box
                    sx={{
                        width: "80vw",
                        height: "80vh",
                        bgcolor: "#000",
                        borderRadius: 1,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        outline: "none"
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: "#3b82f6",
                            color: "#fff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            height: 56,
                            px: 2,
                            flexShrink: 0
                        }}
                    >
                        <Typography variant="h6" fontSize="1rem">
                            Imagem de Intrusão - {selectedAlarmeRow?.data_hora_requisicao}
                        </Typography>

                        <Button
                            onClick={() => setOpenAlarmeImage(false)}
                            sx={{ color: "#fff", minWidth: "auto", fontWeight: "bold" }}
                        >
                            X
                        </Button>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            minHeight: 0
                        }}
                    >
                        {selectedAlarmeImageUrls?.length ? (
                            <img
                                src={selectedAlarmeImageUrls[0]}
                                alt="Imagem de Intrusão"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        ) : (
                            <Typography sx={{ color: "#fff" }}>
                                Nenhuma imagem disponível.
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Modal>

            {/* Modal de Detalhes da Integração Sigma */}
            <Dialog
                open={modalSigmaOpen}
                onClose={() => setModalSigmaOpen(false)}
                maxWidth="md"
                fullWidth
                style={{ zIndex: 215000 }}
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        backgroundColor: '#0f172a',
                        color: '#f8fafc',
                        padding: '16px 24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid #1e293b'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '15px', fontWeight: 700, letterSpacing: '0.3px' }}>
                            Detalhes da Integração Segware Sigma
                        </span>
                        {selectedTarefaSigma?.id_tarefa_sigma ? (
                            <span style={{
                                fontSize: '11px',
                                backgroundColor: '#1e293b',
                                color: '#94a3b8',
                                padding: '2px 8px',
                                borderRadius: '6px',
                                border: '1px solid #334155'
                            }}>
                                ID #{selectedTarefaSigma.id_tarefa_sigma}
                            </span>
                        ) : null}
                    </div>
                    <Button
                        onClick={() => setModalSigmaOpen(false)}
                        style={{
                            color: '#94a3b8',
                            minWidth: '32px',
                            width: '32px',
                            height: '32px',
                            borderRadius: '6px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            padding: 0
                        }}
                    >
                        ✕
                    </Button>
                </DialogTitle>

                <DialogContent style={{ padding: '20px 24px', backgroundColor: '#f8fafc' }}>
                    {selectedTarefaSigma && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            
                            {/* Grid de Informações Chave */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '12px'
                            }}>
                                {/* Rota Utilizada */}
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    padding: '12px 14px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0',
                                    gridColumn: 'span 2'
                                }}>
                                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Rota Utilizada
                                    </div>
                                    <div style={{
                                        fontFamily: 'monospace',
                                        fontSize: '12.5px',
                                        color: '#0f172a',
                                        fontWeight: 600,
                                        marginTop: '4px',
                                        wordBreak: 'break-all'
                                    }}>
                                        {selectedTarefaSigma.rota || 'https://api.segware.io/v3/events/alarm'}
                                    </div>
                                </div>

                                {/* Status HTTP */}
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    padding: '12px 14px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Código de Resposta
                                    </div>
                                    <div style={{ marginTop: '6px' }}>
                                        <span style={{
                                            fontSize: '12px',
                                            fontWeight: 700,
                                            padding: '3px 10px',
                                            borderRadius: '6px',
                                            backgroundColor: (selectedTarefaSigma.codigo_http_resposta >= 200 && selectedTarefaSigma.codigo_http_resposta < 300) ? '#dcfce7' : '#fee2e2',
                                            color: (selectedTarefaSigma.codigo_http_resposta >= 200 && selectedTarefaSigma.codigo_http_resposta < 300) ? '#15803d' : '#b91c1c',
                                            border: `1px solid ${(selectedTarefaSigma.codigo_http_resposta >= 200 && selectedTarefaSigma.codigo_http_resposta < 300) ? '#86efac' : '#fca5a5'}`
                                        }}>
                                            HTTP {selectedTarefaSigma.codigo_http_resposta || 'Sem Resposta'}
                                        </span>
                                    </div>
                                </div>

                                {/* Tipo de Requisição */}
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    padding: '12px 14px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Tipo de Requisição
                                    </div>
                                    <div style={{ fontSize: '13px', fontWeight: 700, color: '#1e293b', marginTop: '4px' }}>
                                        {selectedTarefaSigma.tipo_requisicao || selectedEventoRow?.tipo_requisicao || 'N/A'}
                                    </div>
                                </div>

                                {/* Data e Hora Requisição */}
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    padding: '12px 14px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Data e Hora da Requisição
                                    </div>
                                    <div style={{ fontSize: '12.5px', fontWeight: 600, color: '#0f172a', marginTop: '4px' }}>
                                        {selectedTarefaSigma.data_hora_requisicao 
                                            ? (moment(selectedTarefaSigma.data_hora_requisicao).isValid() 
                                                ? moment(selectedTarefaSigma.data_hora_requisicao).format('HH:mm:ss DD/MM/YYYY') 
                                                : selectedTarefaSigma.data_hora_requisicao)
                                            : '-'}
                                    </div>
                                </div>

                                {/* Data e Hora Resposta */}
                                <div style={{
                                    backgroundColor: '#ffffff',
                                    padding: '12px 14px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Data e Hora da Resposta
                                    </div>
                                    <div style={{ fontSize: '12.5px', fontWeight: 600, color: '#0f172a', marginTop: '4px' }}>
                                        {selectedTarefaSigma.data_hora_resposta 
                                            ? (moment(selectedTarefaSigma.data_hora_resposta).isValid() 
                                                ? moment(selectedTarefaSigma.data_hora_resposta).format('HH:mm:ss DD/MM/YYYY') 
                                                : selectedTarefaSigma.data_hora_resposta)
                                            : '-'}
                                    </div>
                                </div>
                            </div>

                            {/* Body da Requisição */}
                            <div style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    padding: '10px 14px',
                                    backgroundColor: '#f1f5f9',
                                    borderBottom: '1px solid #e2e8f0',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#334155' }}>
                                        Body da Requisição (JSON)
                                    </span>
                                </div>
                                <div style={{
                                    padding: '14px',
                                    backgroundColor: '#0f172a',
                                    color: '#38bdf8',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    lineHeight: '1.5',
                                    maxHeight: '220px',
                                    overflowY: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {(() => {
                                        try {
                                            if (selectedTarefaSigma.corpo_requisicao) {
                                                const parsed = JSON.parse(selectedTarefaSigma.corpo_requisicao);
                                                return JSON.stringify(parsed, null, 2);
                                            }
                                            return 'Sem dados de requisição';
                                        } catch (e) {
                                            return selectedTarefaSigma.corpo_requisicao || 'Sem dados de requisição';
                                        }
                                    })()}
                                </div>
                            </div>

                            {/* Corpo da Resposta */}
                            <div style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    padding: '10px 14px',
                                    backgroundColor: '#f1f5f9',
                                    borderBottom: '1px solid #e2e8f0',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#334155' }}>
                                        Corpo da Resposta
                                    </span>
                                </div>
                                <div style={{
                                    padding: '14px',
                                    backgroundColor: '#0f172a',
                                    color: '#4ade80',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    lineHeight: '1.5',
                                    maxHeight: '180px',
                                    overflowY: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {(() => {
                                        try {
                                            if (selectedTarefaSigma.corpo_resposta) {
                                                const parsed = JSON.parse(selectedTarefaSigma.corpo_resposta);
                                                return JSON.stringify(parsed, null, 2);
                                            }
                                            return 'Sem dados de resposta';
                                        } catch (e) {
                                            return selectedTarefaSigma.corpo_resposta || 'Sem dados de resposta';
                                        }
                                    })()}
                                </div>
                            </div>

                        </div>
                    )}
                </DialogContent>

                <div style={{
                    padding: '12px 24px',
                    backgroundColor: '#f8fafc',
                    borderTop: '1px solid #e2e8f0',
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}>
                    <Button
                        variant="contained"
                        onClick={() => setModalSigmaOpen(false)}
                        style={{
                            backgroundColor: '#334155',
                            color: '#ffffff',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '6px',
                            fontSize: '13px'
                        }}
                    >
                        Fechar
                    </Button>
                </div>
            </Dialog>

        </Grid>
    );


}

